export enum VkOrgCountry {
  Belgium = '6000',
  Germany = '0500',
  Netherlands = '5900',
  Canada = '9900',
  USA = '8100',
  Austria = '5000',
  Poland = '9500',
  France = '0600',
  Switzerland = '6200',
  Luxemburg = '6100',
  Estonia = '7100',
  Italy = '7300',
  Slovakia = '7900',
  Czech = '9700',
  Romania = '7700',
  Slovenia = '7500',
  Croatia = '7600',
  Serbia = '7400',
  UnitedArabEmirates = '8200',
  Ukraine = '9200',
  Lithuania = '8700',
  Latvia = '8900',
  Uzbekistan = '1930',
  Hungary = '9800',
  Bulgaria = '7800',
  Denmark = '6600',
  Finland = '8800',
  UnitedKingdom = '6800',
  Turkey = '8000',
  Sweden = '9600',
  Russia = '9000',
  Spain = '7100',
}
